module.exports = __webpack_public_path__ + "static/media/verify.d481ea39.jpg";